/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarkAllAsReadCommand } from '../models/MarkAllAsReadCommand';
import type { NotificationResponse } from '../models/NotificationResponse';
import type { PushNotificationCommand } from '../models/PushNotificationCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * @param pageNumber
     * @param pageSize
     * @returns NotificationResponse OK
     * @throws ApiError
     */
    public static getApiNotifications(
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<NotificationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Notifications',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static patchApiNotificationsMarkAsRead(
        requestBody?: MarkAllAsReadCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/Notifications/MarkAsRead',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Api to add push notification token
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiNotificationsPushnotificationToken(
        requestBody?: PushNotificationCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Notifications/pushnotification/token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
}
